import awsdk from 'awsdk';

// OFFLINE
// PHONE_BUSY
// PHONE_AVAILABLE
// WEB_BUSY
// WEB_AVAILABLE

export const ProviderVisibility = awsdk.AWSDKProviderVisibility;
export type ProviderVisibility = typeof ProviderVisibility;
